import React, { useMemo } from 'react';
import { Collapse, FormGroup, ControlLabel } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Tooltip from '../../../../../../../../components/Tooltip';
import FormSwitch from '../../../../../../../../components/FormSwitch';
import { getOptions, getSelectedValue } from './helper';
import SelectVirtualized from '../../../../../../../../components/Select/Virtualized';
import * as types from '../../reducer/constants';
import FieldIgnoreCompletedStatus from '../IgnoreCompletedStatus';
import accessFields from '../../WrapperComponents/AccessFields/access';

const FieldAutoComplete = ({ form, dispatchServiceData }) => {
  const { startCounts, config } = useSelector((state) => state.services);
  const { start_count, auto_complete, mode } = form;

  const selectOptions = useMemo(() => getOptions(startCounts), [startCounts]);
  const selectedValue = useMemo(() => getSelectedValue(startCounts, start_count), [startCounts, start_count]);

  const showCounts = auto_complete;
  const showIgnoreCompletedStatusFromProvider = accessFields.ignoreCompletedStatusFromProvider(form, config);

  const onChange = () => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_AUTO_COMPLETE, value: !showCounts })

    /**
     * Если Autocomplete включаем, то автоматически
     * Надо поменять auto_complete_ignore_provider = true
     * При условии, если это Mode = 1
     */
    if (mode === 1 && !showCounts) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_AUTO_COMPLETE_IGNORE_PROVIDER, value: true })
    }
  };

  return (
    <>
      <FormSwitch id="auto_complete_switch" name="auto_complete_switch" checked={showCounts} onChange={onChange}>
        Auto Complete
        {' '}
        <Tooltip
          placement="top"
          text={(
            <p>
              The system periodically checks
              <br />
              {' '}
              current count and change status
              <br />
              {' '}
              when order completed.
              <br />
              {' '}
              It is a paid feature
              <br />
              {' '}
              and costs one parsing credit
              <br />
              {' '}
              per 24 hours for each order.
            </p>
          )}
          tooltipClass="tooltip__top"
        >
          <span className="fas fa-info-circle cursor-help" />
        </Tooltip>
      </FormSwitch>
      <Collapse in={showCounts}>
        <div className="mt-10">
          <FormGroup className="form-group__autocomplete-count">
            <ControlLabel htmlFor="start_count_auto_complete">Count</ControlLabel>
            <SelectVirtualized
              components={{ IndicatorSeparator: null }}
              name="start_count_auto_complete"
              isDisabled
              noOptionsMessage={() => 'Not found count'}
              hideSelectedOptions={false}
              value={selectedValue}
              options={selectOptions}
              placeholder="Choose count"
            />
          </FormGroup>
          {showIgnoreCompletedStatusFromProvider ? <FieldIgnoreCompletedStatus form={form} dispatchServiceData={dispatchServiceData} /> : null }
        </div>
      </Collapse>
    </>
  );
};

FieldAutoComplete.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldAutoComplete;
